import { FaqItems } from "./types";

export const faqItems: FaqItems = [
  {
    index: 1,
    category: "Frequenty asked questions about Keyzy",
    question: "Who are Keyzy?",
    answer:
      "Keyzy is a company that helps people get onto the property ladder with our rent-to-own product. We buy new homes from developers, rent them out for two years to people who are not yet ready to buy, and at the end of their lease, sell the home at a pre agreed price. Each month, 100% of your rent is reserved to use as deposit later on if you choose to buy.",
  },
  {
    index: 2,
    category: "Frequenty asked questions about Keyzy",
    question: "How is Keyzy different from a traditional mortgage?",
    answer:
      "Keyzy does not provide mortgages. We offer our homes on a rent-to-own basis. This means you rent for two years, build up a deposit and then buy later with a mortgage when you’re ready.",
  },
  {
    index: 3,
    category: "Frequenty asked questions about Keyzy",
    question: "How exactly does the converted rent work?",
    answer:
      "Every month, your full rent amount is going towards decreasing your future buyback price. Over time, this converted rent grows and can be used to purchase the home from Keyzy.",
  },
  {
    index: 4,
    category: "Frequenty asked questions about Keyzy",
    question: "Do I need to pay anything upfront to use Keyzy?",
    answer:
      "The only upfront amount due is a one-off capital payment made on the grant of your contractual right to buy your home — this is your Future Purchase Agreement. It costs £499 for 1 applicant, £999 for 2, or £1,499 for 3 or more. After that, the only thing you pay to us is your monthly rent.",
  },
  {
    index: 5,
    category: "Frequenty asked questions about Keyzy",
    question: "What if I want to buy the home sooner than expected?",
    answer:
      "If you’re ready to purchase earlier, you can do so, however there is a fee for ending your agreement early. This fee is 2% of the full purchase price of the home. Up to 100% of the rent you’ve already paid will go directly toward the buying the property from us. The future buyback price will be the pre-agreed price minus all the rent paid until purchase date.",
  },
  {
    index: 6,
    category: "Frequenty asked questions about Keyzy",
    question: "What happens if I decide not to purchase?",
    answer:
      "If your circumstances change and you choose not to buy, you’ll have the flexibility to walk away at the end of your rental term, subject to any agreed-upon conditions. However, your accrued converted rent may be impacted. Alternatively, you can decide to find a buyer on the open market and you will get the difference between the sale price and the future buyback price minus all your rental payments.     Example: your future buyback price is £500,000 and after two years you have paid £50,000 of rent. You decide to sell the property for £500,000. In that case you would get £50,000 back minus any fees paid as part of the transaction (agents, conveyancing etc. which we would let you know about before proceeding).",
  },
  {
    index: 7,
    category: "Frequenty asked questions about Keyzy",
    question: "Is Keyzy available for any property?",
    answer:
      "Keyzy is available in select regions and for properties that have been pre selected and that meet our criteria (price, condition, location, etc.). Browse our Find a Home section to see all available properties. If you have a specific home in mind, reach out to our team to check if we can help.",
  },
  {
    index: 8,
    category: "Frequenty asked questions about Keyzy",
    question: "Who is responsible for maintenance and repairs?",
    answer:
      "You’ll typically be responsible for minor, day-to-day upkeep, while Keyzy will handle larger structural or significant repairs until you’ve purchased the home. Specific responsibilities are detailed in your agreement.",
  },
  {
    index: 9,
    category: "Frequenty asked questions about Keyzy",
    question: "How do I qualify?",
    answer:
      "We look at factors like income stability and general creditworthiness, but our requirements are usually more flexible than a traditional mortgage lender’s. Get in touch to see if you qualify.",
  },
  {
    index: 11,
    category: "Frequenty asked questions about Keyzy",
    question: "How is Keyzy able to give back all my rent and still make money?",
    answer:
      "Keyzy is a rent-to-own company. We exist to sell homes to first time buyers and help people onto the property ladder. We’ve got no interest in being long-term landlords. We make money by selling the home to you at the end of your 2-year tenancy. We work with investors and developers to make lots of new-build homes available on our rent-to-own product. We believe in this model because we know there are loads of people out there who want to buy a home but need a little help to get ready before they do. There is also a one-off capital payment made on the grant of your contractual right to buy your home — this is your Future Purchase Agreement. It costs £499 for 1 applicant, £999 for 2, or £1,499 for 3 or more. After that, the only thing you pay to us is your monthly rent.",
  },
  {
    index: 12,
    category: "Frequenty asked questions about Keyzy",
    question: " How do I get started?",
    answer:
      "There’s a couple of ways to get started. Either browse through our properties and book a viewing for something you like. Or, register and get started with your full application to get pre-approved.",
  },
  {
    index: 13,
    category: "Frequenty asked questions about Keyzy",
    question: "What are the eligibility criteria?",
    answer:
      "There are a number of things we look at when reviewing applications to join Keyzy. Before starting a full application and to get your Budget in Principle you and any joint applicants will need to confirm that:<br><br>• You are over 18 and have the right to live and work in the UK<br>• Your combined household income is at least £80,000 (this is because of the current cheapest apartment available and is subject to change)<br>• You haven't entered into an IVA or bankruptcy in the past three years<br>• You haven't had any CCJ's or defaults registered against you in the past 12 months<br>• You haven't missed any payments in the past six months (e.g. phone bills or rent payments).<br><br>When you submit a full application we will also do an industry-standard check on you using secure and modern technology including:<br><br>• Verifying your income and spending (using Open Banking)<br>• Verifying your ID digitally. This only takes a few minutes with no need to post anything to us.<br>• Checking for fraud and bankruptcy (using Credit bureaus).",
  },
  {
    index: 14,
    category: "Frequenty asked questions about Keyzy",
    question: "Can I get help from family?",
    answer:
      "If applying to Keyzy jointly with a family member, both of you must live in the home as your main residence. At the moment we don&#39;t offer an option to use a guarantor.",
  },
  {
    index: 16,
    category: "Frequenty asked questions about Keyzy",
    question: "What happens if I want to move somewhere else?",
    answer:
      "You can give 2 months' notice to terminate your lease, however we still want you to get any potential increase in the property value. You can find a buyer for the home at any time during your lease, and keep all the upside. You just need to make sure it is sold at a price equal or above your future buyback price. You also get up to 100% of your rental payments back (minus an early exit fee of 2% for selling the home).",
  },
  {
    index: 17,
    category: "Frequenty asked questions about Keyzy",
    question: "What if I can't get a mortgage at the end of the lease?",
    answer:
      "You may be able to extend your lease agreement while you get ready to buy. If you still can't get a mortgage you can find another buyer and walk away with the gains if the property value has increased.",
  },

  {
    index: 12,
    category: "Terminology",
    question: "What is the future buyback price?",
    answer:
      "The future buyback price (the amount you’ll pay to purchase the home at the end of the rental period) is <b>agreed upon up-front</b>. This ensures you know exactly how much the property will cost when you’re ready to buy, providing <b>price certainty</b> and avoiding any unwelcome surprises down the line.",
  },
  {
    index: 13,
    category: "Terminology",
    question: "What is converted rent?",
    answer:
      "<b>Converted rent</b> is the portion of your monthly rent that is applied toward decreasing your future buyback price. In our new Rent-to-Own model, up to <b>100% of each rent payment</b> is converted, meaning it goes straight towards your deposit, helping you build equity faster.",
  },
];
